import o from "./index825.js";
import p from "./index826.js";
import a from "./index827.js";
var r = a && a.isMap, m = r ? p(r) : o;
export {
  m as default
};
